import React from "react";
import { PlanComparisonContainer } from "../../styled/info";
import { FaCheck } from "react-icons/fa6";
import { subscription } from "../common/plans";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";

const PlanComparison = () => {
  const setting = useSelector((state) => state?.user?.setting);
  const { pathname } = useLocation();

  return (
    <PlanComparisonContainer className={pathname.includes("mypage") ? setting?.mode : "infoPlan"}>
      <div className="header">
        <div></div>
        {subscription.tiers.map((tier) => (
          <div key={tier.tier} className={tier.tier}>
            <strong>{tier.tier}</strong>
            {tier.price ? (
              <div className="price">
                {typeof tier.price === "number" ? (
                  <span>0원</span>
                ) : (
                  <>
                    <span className="origin">{tier.price.original}</span>
                    <span>{tier.price.discounted}</span>
                  </>
                )}
              </div>
            ) : null}
          </div>
        ))}
      </div>
      {subscription.features.map((feature) => (
        <div key={feature.name} className="row">
          <div>{feature.name}</div>
          {subscription.tiers.map((tier) => (
            <div key={tier.tier}>
              {feature.tiers.includes(tier.tier) ? <FaCheck /> : <span>-</span>}
            </div>
          ))}
        </div>
      ))}
    </PlanComparisonContainer>
  );
};

export default PlanComparison;
